<template>
  <div class="index-section">
    <video :autoplay="false" :ref="'video' + 1" :src="data.attachment" controls :poster="data.posterDataUrl"
      class="video" @loadeddata="captureFrame(1)" crossorigin="anonymous" />
    <div class="test">
      {{ data.title }}
    </div>
  </div>
</template>

<script>
import { getSafeVideoUrl } from "@/utils/urlValidator";

export default {
  data() {
    return {
      data: {}
    };
  },
  computed: {},
  activated() {
    // 直接使用query中的对象，无需JSON.parse
    let rawData = this.$route.query.data;
    
    // 添加URL安全验证
    if (rawData && rawData.attachment) {
      rawData.attachment = getSafeVideoUrl(rawData.attachment, '');
      if (!rawData.attachment) {
        this.$message.error('视频资源不安全，已被系统拦截');
      }
    }
    
    this.data = rawData;
  },

  methods: {
    captureFrame(index) {
      const video = this.$refs['video' + index];
      video.currentTime = 1;
      video.addEventListener('seeked', () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/png');
        this.$set(this.list[index], 'posterDataUrl', dataUrl);
      }, { once: true });
    }

  },
};
</script>

<style scoped lang="scss">
.index-section {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #000;
}

.video {
  width: 100%;
  height: 100%;
}

.test {
  width: 100%;
  padding: 10px;
  position: absolute;
  top: 50px;
  color: #fff;
}
</style>